import { render, staticRenderFns } from "./AnnualReportUploaderComponent.vue?vue&type=template&id=bc50c182&"
import script from "./AnnualReportUploaderComponent.vue?vue&type=script&lang=js&"
export * from "./AnnualReportUploaderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports